import { render, staticRenderFns } from "./ProductQualityMgmt.vue?vue&type=template&id=8f8570e2"
import script from "./ProductQualityMgmt.vue?vue&type=script&lang=js"
export * from "./ProductQualityMgmt.vue?vue&type=script&lang=js"
import style0 from "./ProductQualityMgmt.vue?vue&type=style&index=0&id=8f8570e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports